// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__19A_-","rootSmall":"AddTileButton_rootSmall__3Y-je"};